export var OPTION_LIST_CLASS_PREFIX = 'OptionList';
export var OPTION_LIST_ITEM_CLASS_PREFIX = 'OptionListItem';
export var OPTION_LIST_FOOTER_CLASS_PREFIX = 'OptionListFooter';
export var OPTION_LIST_ITEM = 'OptionListItem';
export var MAX_OPTIONS_SELECT_ALL_THRESHOLD = 10000;